import React from "react";
import { graphql, Link, useStaticQuery } from "gatsby";
import { FiArrowRight } from "react-icons/fi";
import { GatsbyImage } from "gatsby-plugin-image";

export default function BlogSectionTwo() {
  const data = useStaticQuery(graphql`
    query {
      allWpPost {
        nodes {
          slug
          title
          date(formatString: "LL")
          featuredImage {
            node {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
              }
              altText
            }
          }
        }
      }
    }
  `);

  return (
    <div className="md:max-w-2xl 2md:max-w-3xl lg:max-w-4xl xl:max-w-6xl mx-3 md:px-0 mb-16 md:mb-24 md:mx-auto">
      <div className="text-center mb-7 md:mb-12">
        <h2 className="text-gray-8 text-2xl md:text-4xl">
          Latest news and inspirational stories
        </h2>
        <p className="text-black text-base md:text-lg">
          Check out our latest blog posts, articles, client success stories and
          essential announcement.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 ">
        {data &&
          data.allWpPost.nodes.slice(0, 3).map((node, index) => (
            <Link
              to={"../blogs/" + node.slug}
              itemProp="url"
              className="group w-full hover:pointer"
            >
              <div className="relative group-hover:scale-[1.02] ease-out duration-300 w-full aspect-video rounded-md overflow-hidden">
                <GatsbyImage
                  className="absolute w-full h-full"
                  key={index}
                  alt={node.title}
                  image={
                    node.featuredImage.node.localFile.childImageSharp
                      .gatsbyImageData
                  }
                />
              </div>

              <div className="relative mx-5 mt-5">
                <div className="mb-2.5">
                  <Link
                    to={"../blogs/" + node.slug}
                    itemProp="url"
                    className="btn btn-light-round btn-round text-color-red category-btn"
                  >
                    Technology
                    <FiArrowRight className="inline text-[12px] font-bold" />
                  </Link>
                  <span className="text-blog-date-color text-sm ml-4">
                    {" "}
                    {node.date}
                  </span>
                </div>
                <h5 className="text-gray-8 group-hover:text-color-red">
                  <Link to={"../blogs/" + node.slug} itemProp="url">
                    {node.title}
                  </Link>
                </h5>
              </div>
            </Link>
          ))}
      </div>
    </div>
  );
}
